import React, { useState } from 'react';
import { Send, MessageCircle } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from '@/components/ui/alert-dialog';

const CHANNELS = {
  email: {
    path: 'send', icon: Send, label: 'correo', variant: 'default',
    note: 'usando la última versión guardada del mensaje, desde bienvenida@soporte.tuiglesia.app. Se omiten las que están de baja o sin correo.',
  },
  whatsapp: {
    path: 'send-whatsapp', icon: MessageCircle, label: 'WhatsApp', variant: 'outline',
    note: 'con la plantilla aprobada (con o sin la línea del correo, según tenga correo). Se omiten las que están de baja o sin WhatsApp. Mientras Meta no verifique tu negocio, el límite es de unas 50 conversaciones nuevas al día.',
  },
};

export function SendWelcomeButton({ campaign, selected, pending, onDone, channel = 'email' }) {
  const [resend, setResend] = useState(false);
  const ch = CHANNELS[channel];
  const Icon = ch.icon;
  const hasSel = selected.length > 0;
  const target = hasSel ? `${selected.length} congregaciones seleccionadas` : `${pending} congregaciones pendientes`;

  const send = async () => {
    try {
      const { data } = await api.post(`/campaigns/${campaign.id}/${ch.path}`, { contact_ids: hasSel ? selected : null, resend: hasSel && resend });
      toast.success(`Enviando ${data.queued} mensajes de bienvenida por ${ch.label}`);
      setResend(false);
      onDone();
    } catch (e) {
      toast.error(errText(e, 'No se pudo enviar'));
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant={ch.variant} disabled={!hasSel && pending === 0} data-testid={`contacts-send-${channel}-button`}>
          <Icon className="h-4 w-4 mr-1" />{hasSel ? `${ch.label} a ${selected.length}` : `Bienvenida por ${ch.label} (${pending})`}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid={`contacts-send-${channel}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Enviar la bienvenida por {ch.label}?</AlertDialogTitle>
          <AlertDialogDescription>Se enviará a {target} {ch.note}</AlertDialogDescription>
        </AlertDialogHeader>
        {hasSel && (
          <label className="flex items-center gap-2 text-sm">
            <Checkbox checked={resend} onCheckedChange={(v) => setResend(!!v)} data-testid={`contacts-send-${channel}-resend`} />
            Reenviar también a las que ya lo recibieron
          </label>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`contacts-send-${channel}-cancel`}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={send} data-testid={`contacts-send-${channel}-confirm`}>Enviar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
